﻿import { defineStore } from 'pinia'
import { UrlEnum, UnionEnum } from '@jms/utils/enums/Route'

export interface TabIn {
  name: string
  path: string
  dedupKey?: string
  meta: any
}

export interface TabParams {
  serviceSiteCode: string
  startTime: string
  endTime: string
}

export const useTabStore = defineStore('tabs', {
  state: () => ({
    tabs: [] as TabIn[],
    tabsParams: {} as TabParams
  }),
  getters: {
    getTabs: (state) => state.tabs,
    getTabsParams: (state) => state.tabsParams
  },
  actions: {
    setTabs(menuItem: TabIn) {
      //404椤甸潰涓嶅姞鍏abs
      if (['/notFound'].includes(menuItem.dedupKey ?? menuItem.path)) return

      const findItemIndex = this.tabs.findIndex((_) => (_.dedupKey ?? _.path) === (menuItem.dedupKey ?? menuItem.path))
      if (findItemIndex === -1) {
        this.tabs.push(menuItem)
      } else {
        this.tabs[findItemIndex] = menuItem
      }
    },
    setTabsParams(params: TabParams) {
      this.tabsParams = params
    },
    delTabs(path: string) {
      const index = this.tabs.findIndex((_) => _.path === path)
      this.tabs.splice(index, 1)
    }
  },
  persist: {
    storage: localStorage
  }
})
